import joinForm from '@grins/fd-modules/bonz/joinNow/joinForm';
import perksModal from '@grins/fd-modules/bonz/shared/perksModal';

function run() {
  joinForm.init();
  perksModal.init();
}
run();
